import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { AssetDao } from '@app/dao/asset/asset.dao';
import { ProductDao } from '@app/dao/product/product.dao';
import { UserDao } from '@app/dao/user/user.dao';
import * as _ from 'lodash';
import { BehaviorSubject, combineLatest, Subject, switchMap } from 'rxjs';
import { PrPeaFormBuilder } from './ea-pea-form.builder';

@Component({
    selector: 'ea-pea-form',
    templateUrl: './ea-pea-form.component.html',
    styleUrls: ['./ea-pea-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaPeaFormComponent),
        },
    ],
    standalone: false
})
export class EaPeaFormComponent extends PrPeaFormBuilder implements OnInit {
  users: any[];
  references: any;
  groupes: any[];
  sources: any[];
  managers: any[];
  products: any[] = [];
  _ = _;
  doneSubject: Subject<void> = new Subject<void>();
  tabChanged: BehaviorSubject<any> = new BehaviorSubject(null);
  changeTab: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    protected formConstructor: PrFormConstructor,
    private userDao: UserDao,
    private assetDao: AssetDao,
    private productsDao: ProductDao,
  ) {
    super(formConstructor);
  }

  ngOnInit(): void {
    combineLatest([
      this.userDao.getCouple(),
      this.assetDao.getReferences(),
      this.assetDao.getProviders({
        productType: 'PEA',
        status: ['VALID'],
      }),
      this.productsDao.getProducts({ type: ['PEA'] }),
    ]).subscribe(([users, references, managers, products]) => {
      this.users = users;
      this.references = references;
      this.sources = references[0];
      this.managers = managers;
      this.products = _.sortBy(products, 'name');
      this.setDefaultValue();
    });
  }

  get title() {
    return this.generateTitle("Modifier l'actif", 'Ajout d’un PEA');
  }

  generateTitle(editTitle: string, addTitle: string) {
    if (!this.entity || !this.entity.id) return addTitle;
    if (!this.entity.label || this.entity.label === '') return editTitle;
    return `${editTitle} “${this.entity.label}”`;
  }

  selectType(type) {
    this.form.controls.type.setValue(type);
    this.form.updateValueAndValidity();
    this.assetDao.getProviderByType(type).subscribe(res => {
      this.managers = res;
    });
  }

  setDefaultValue() {
    // if (this.entity.label) this.form.get('product').setValue(_.find(this.products, p => p.name === this.entity.label))
    if (this.entity.owners && this.entity.owners.length)
      this.form.get('owners').setValue(this.buildInitialOwners(this.entity));
  }

  onSubmit() {
    this.displayErrors();

    this.selectErrorInput();

    if (this.form.invalid) {
      this.changeTab.next('FIRST');
      return;
    }

    this.prFormService.loading();
    let formDTOExtraction = this.extract();

    this.assetDao
      .proposeManagerProvider(formDTOExtraction, this.managers)
      .pipe(switchMap(() => this.assetDao.saveAssets(formDTOExtraction)))
      .subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          this.notificationService.success('La sauvegarde a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La sauvegarde a échoué');
        },
      );
  }

  onCancel() {
    this.prFormService.close();
  }

  onTabChange(isLastTab: boolean) {
    this.tabChanged.next(isLastTab);
  }

  nextTab() {
    this.changeTab.next('NEXT');
  }
}
